<template>
  <hm-sync>
    <div class>
      <div class="table-panel flex flex-end">
        <div>
          <el-input
            clearable
            v-model.trim="keyWords"
            placeholder="输入分类名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <el-table
        @sort-change="sortChange"
        :data="goodsCategoryList.records"
        style="width: 100%"
        stripe
        size="small"
        border
        lazy
        row-key="categoryId"
        :load="load"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          label="类目名称"
          width="180"
          prop="categoryName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryLogo"
          label="类目图标"
          width="180"
        >
          <template slot-scope="scope">
            <img style="width: 40px" :src="scope.row.categoryLogo" alt />
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryLevel"
          label="级别"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="relationSpu"
          sortable
          label="商品数量"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="设置">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="moveTo(scope.row)"
              >查看商品</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="goodsCategoryList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-sync>
</template>

<script>
import HmSync from "@/components/HmIsSync";
import { mapGetters } from "vuex";
export default {
  components: {
    HmSync
  },
  data() {
    return {
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1,
                curCategoryId: this.currentRow.categoryId,
                syncFlag: "erp"
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId,
                syncFlag: "erp"
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      title: "",
      keyWords: "",
      sort: {},
      level: 0,
      parentCategoryId: "",
      parentCategoryName: "",
      dialogVisible: false,
      categoryName: "",
      currentRow: {},
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: mapGetters(["goodsCategoryList"]),
  watch: {
    "goodsCategoryList.total": {
      handler(val) {
        if (
          val == (this.currentPage - 1) * this.pageSize &&
          this.pageTotal != 0
        ) {
          this.currentPage -= 1;
          this.queryList();
        }
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    sortChange(sort) {
      this.sort = sort;
      this.queryList();
    },
    moveTo(row) {
      this.$router.push({
        name: "StoreGoodsList",
        query: {
          categoryId: row.categoryId,
          syncFlag: "erp"
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("queryGoodsCategoryList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        keyWords: this.keyWords,
        order: this.sort.order,
        prop: this.sort.prop,
        syncFlag: "erp"
      });
    },
    search() {
      this.queryList();
    },
    load(tree, treeNode, resolve) {
      const { categoryLevel, categoryId } = tree;
      resolve([]);
      this.$store
        .dispatch("queryGoodsCategoryListByParent", {
          parentCategoryId: categoryId,
          categoryLevel: +categoryLevel + 1,
          pageNo: 1,
          pageSize: 999,
          syncFlag: "erp"
        })
        .then(res => {
          if (res.code === "0" && res.result.records.length) {
            res.result.records.forEach(v => {
              v.hasChildren = Boolean(v.isChild);
            });
            resolve(res.result.records);
          } else {
            resolve([]);
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.logo {
  width: 80px;
}
</style>
